/**
 * Created by nijin on 5/12/16.
 */
import { Injectable, Optional, SkipSelf } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import {Observable} from 'rxjs';

export interface SpinnerState {
  show: boolean;
}

@Injectable()
export class SpinnerService {
  private spinnerSubject = new Subject<SpinnerState>();

    spinnerState = this.spinnerSubject.asObservable();

  constructor(@Optional() @SkipSelf() prior: SpinnerService) {
    if (prior) { return prior; }
  }

  getSpinnerState(): Observable<SpinnerState> {
      return this.spinnerState;
  }

  show(): void {
    this.spinnerSubject.next(<SpinnerState>{ show: true});
  }

  hide(): void {
    this.spinnerSubject.next(<SpinnerState>{ show: false });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/spinner/spinner.service.ts